module.exports = __webpack_public_path__ + "img/emitFacefilter05.48442e71.png";